<template>
  <div class="content-box mt-20 flex column gap-20 flex-1">
    <div class="section-box outline flex flex-1">
      <div style="flex: 1; display: flex; flex-direction: column">
        <div class="das-form-container gap-0 flex column flex-1">
          <div class="das-form-title-container justify-space-between">
            <div
              class="das-form-title flex align-center"
              style="justify-content: space-between; width: 100%"
            >
              <span class="main-title"> Danh sách giao dịch </span>
              <span
                >Số dư:
                <span style="font-weight: 700; color: #357456"
                  >{{ $displayCurrency(totalMoneyInPage) || 0 }} VND</span
                >
              </span>
            </div>
          </div>
          <hr />
          <span v-if="tabList.length === 0"
            >Dữ liệu danh sách giao dịch trống</span
          >
          <div v-else class="flex column gap-0 flex-1">
            <tab
              id="transaction-transaction-list"
              v-model="tabIndex"
              :tab-list="tabList"
              @input="onTabChange"
            />

            <div
              v-for="(item, index) in tabList"
              :key="index"
              class="mt-10 none flex-1"
              :class="{ block: tabIndex === index + 1 }"
            >
              <GridVx
                v-if="tabIndex === index + 1"
                ref="transactionGrid"
                :columns="transactionCols"
                :row-class-rules="rowClassRules"
                :auto-select-first-row="false"
                :row-multi-select-with-click="true"
                dom-layout="scroll"
                :rows="transactionRows"
                :context="context"
                class="agGrid"
                @selectionChanged="onRowClicked"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 0; opacity: 0">
      <iframe
        v-if="detailInvoiceDialogVisible"
        width="100%"
        height="100%"
        :src="
          currSelectedRow
            ? `/cashier/folio?id=${currSelectedRow}`
            : `/cashier/folio?subBookingGroupId=${bookingInfo?.id}`
        "
      ></iframe>
      <!-- <iframe
        v-if="allDetailInvoiceDialogVisible"
        width="100%"
        height="100%"
        :src="`/cashier/folio?subBookingGroupId=${bookingInfo.id}`"
      ></iframe> -->
    </div>
  </div>
</template>

<script>
import Tab from '@/components/Tab'
import {
  getTransactionByPage,
  getTranPageById
} from '@/api/cashier_service/postTransaction'
import { CellRenderUnderscoreText } from '@/utils/cellRenders'
import bus from '@/utils/bus'
// import { cellRenderUnderscoreText } from './components/cellRendererUnderscoreText.vue'
export default {
  components: {
    Tab,
    // eslint-disable-next-line vue/no-unused-components
    // CellRenderCheckboxReadonly
    // eslint-disable-next-line vue/no-unused-components
    CellRenderUnderscoreText
  },
  props: {
    // this prop for reload data in Grid
    // paymentIndex: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      context: null,
      detailInvoiceDialogVisible: false,
      currSelectedRow: null, // folio
      rowClassRules: {
        paid: function (param) {
          return param.data.invoice_number_sequence
        }
      },
      tabIndex: 1, // 1 - 3
      transactionRows: [],
      totalMoneyInPage: 0,
      tabList: [],
      transactionCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.transactionDate'),
          field: 'trans_date',
          valueGetter: params => {
            return (
              this.$moment(params?.data?.trans_date).format('DD-MM') || null
            )
          },
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.invoiceNumberSequence'),
          field: 'invoice_number_sequence',
          tooltipField: 'invoice_number_sequence',
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.folioNum'),
          field: 'folio_num',
          tooltipField: 'folio_num',
          cellRenderer: 'CellRenderUnderscoreText',
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'description',
          tooltipField: 'description',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'sub_transaction_desc',
          tooltipField: 'sub_transaction_desc',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'money',
          valueGetter: params => {
            return Number(params.data?.money).toLocaleString('en') || null
          },
          maxWidth: 150
        },
        {
          headerName: 'Loại GD',
          field: 'refund',
          // cellRenderer: 'CellRenderCheckboxReadonly',
          valueGetter: param => {
            if (param.data?.refund) {
              return 'Hoàn tiền'
            } else if (param.data?.deposit) {
              return 'Đặt cọc'
            } else {
              return '-'
            }
          },
          // cellClass: 'grid-cell-align-center',
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.initRoom'),
          field: 'room_num',
          tooltipField: 'room_num',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.staff'),
          field: 'staff_name',
          tooltipField: 'staff_name',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.createdTime'),
          field: 'create_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.create_date) || null
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note',
          minWidth: 250
        }
      ]
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    key() {
      return this.$store.getters['key']
    },
    transactionListIndex() {
      return this.$store.getters['transactionListIndex']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    }
  },
  watch: {
    key() {
      this.transactionRows = []
      this.tabList = []
      if (this.bookingInfo?.id) {
        this.getTranPageById(this.bookingInfo.id, true)
      }
    },
    async transactionListIndex() {
      await this.getTranPageById(this.bookingInfo.id)
      this.tabIndex = 1
      this.$store.dispatch('cashier/addSelectedTab', this.tabList[0])
      const tabId = this.selectedTab?.value || null
      await this.getTransactionByPage(tabId)
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    bus.$on('post_transaction/show_print_detail_invoice_dialog', () => {
      // if(this.allDetailInvoiceDialogVisible)
      // if(detailInvoiceDialogVisible)
      this.downloadDetailInvoice()
    })
  },
  methods: {
    onRowClicked(row) {
      this.$store.dispatch('cashier/addTransactions', row)
    },
    async getTranPageById(id, resetTab = false) {
      const params = {
        id: id
      }
      const data = await getTranPageById(params)
      this.tabList = data.data.page.map(item => {
        return {
          label: item.code,
          value: item.id,
          desc: item.desc
        }
      })
      const emitedMoney = data.data.total_money
      const depositedMoney = data.data.total_deposit
      const checkoutPermitFromApi = data.data.check_out
      this.$emit(
        'emitedMoneyChanged',
        emitedMoney,
        depositedMoney,
        checkoutPermitFromApi
      )
      // alert(emitedMoney)
      this.$store.dispatch('cashier/addTabList', this.tabList)
      if (resetTab) {
        this.tabIndex = 1
        this.$store.dispatch('cashier/addSelectedTab', this.tabList[0])
      }
      await this.getTransactionByPage(this.tabList[0]?.value || null)
    },
    async onTabChange(idx) {
      // alert(1)
      this.$store.dispatch('cashier/addSelectedTab', this.tabList[idx - 1])
      await this.getTransactionByPage(this.tabList[idx - 1].value)
    },
    async getTransactionByPage(page) {
      this.$store.dispatch('cashier/addTransactions', [])
      const params = {
        id: this.bookingInfo.id,
        transPage: page
      }
      if (!page) {
        this.totalMoneyInPage = 0
        this.transactionRows = []
        return
      }
      const data = await getTransactionByPage(params)
      this.transactionRows = data.data
      this.totalMoneyInPage = data.total
    },
    onClickFolio(params) {
      console.log('clicker clicker', params)
      this.currSelectedRow = params.data.id
      bus.$emit('post_transaction/show_print_detail_invoice_dialog')
    },
    downloadDetailInvoice() {
      console.log('ledoan', this.bookingInfo.id)
      this.detailInvoiceDialogVisible = true
      setTimeout(() => {
        this.currSelectedRow = null
        this.detailInvoiceDialogVisible = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.block {
  display: block;
}
.paid {
  background-color: #fff9c4 !important;
}
</style>
